import {
    useDerivativesCommodityMarketContext
} from "../../../../context/derivatives/commodity-market/DerivativesCommodityMarketContext";
import Table from "../../../../components/table/Table";
import {FutureContractHeaderName} from "../../../../components/tableHeaderNames/HeaderName";
import {Skeleton} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import TableFilteredByKey from "../../../../components/table/TableFilteredByKey";
import DerivativesCommodityMarketFutureContractsForm from "./DerivativesCommodityMarketFutureContractsForm";

const DerivativesCommodityMarketFutureContract = () => {
    const {tableData, increaseRate, filteredTableData, excludeSaffron} =
        useDerivativesCommodityMarketContext();

    const uniqueBaseEquities = () => {
        if (!tableData?.data) return [];

        let baseEquities = tableData.data.map(item => item.base_equity_name);

        if (excludeSaffron) {
            baseEquities = baseEquities.filter(name => !name.includes("زعفران"));
        }

        return [...new Set(baseEquities)];
    };

    return (
        <Grid2 container spacing={2}>
            <Grid2 xs={12}>
                <TableFilteredByKey title={"دارایی پایه"} data={uniqueBaseEquities()} isLoading={tableData.isLoading}/>
            </Grid2>

            <Grid2 xs={12}>
                <Table
                    tableData={filteredTableData}
                    faCols={FutureContractHeaderName}
                    height="75vh"
                    tableTitle={{
                        title: "قراردادهای آتی",
                        desc: increaseRate.isValidating ? (
                            <Skeleton width="311px" height="18px"/>
                        ) : (
                            `سود ماهانه بانکی (${increaseRate?.data?.monthly_interest_rate}%) در محاسبه اسپرد ماهانه لحاظ شده است`
                        ),
                    }}
                    Form={DerivativesCommodityMarketFutureContractsForm}
                />
            </Grid2>
        </Grid2>
    );
};

export default DerivativesCommodityMarketFutureContract;
